// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "v4.3.1-13687-g63c61846fb-dirty",
    "hash": "g63c61846fb",
    "distance": 13687,
    "tag": "v4.3.1",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v4.3.1",
        "major": 4,
        "minor": 3,
        "patch": 1,
        "prerelease": [],
        "build": [],
        "version": "4.3.1"
    },
    "suffix": "13687-g63c61846fb-dirty",
    "semverString": "4.3.1+13687.g63c61846fb",
    "version": "version-10.23.2",
    "buildTime": "2026-11-02T06:03:40.844Z"
};
/* eslint-enable */
